import * as React from 'react';
import Box from '@mui/material/Box';
import SFQrScannerIcon from '../icons/sf-qr-scanner-icon';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import SFPointOutlinedIcon from '../icons/sf-point-outlined-icon';
import Typography from '@mui/material/Typography';
import { fontWeight } from '@/theme';
import SFPointFilledIcon from '../icons/sf-point-filled-icon';
import SFWalletOutlinedIcon from '../icons/sf-wallet-outlined-icon';
import SFWalletFilledIcon from '../icons/sf-wallet-filled-icon';
import SFStoreOutlinedIcon from '../icons/sf-store-outlined-icon';
import SFMyOutlinedIcon from '../icons/sf-my-outlined-icon';
import SFMyFilledIcon from '../icons/sf-my-filled-icon';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import { qr_camera_call } from '../linkMobile/qrCam';

type LabelType = '포인트' | '지갑' | '스캔' | '스토어' | 'MY';

function BottomNavigationItem({
  icon,
  selectedIcon,
  label,
  selected,
  onClick,
}: {
  icon: React.ReactNode;
  selectedIcon?: React.ReactNode;
  label: LabelType;
  selected?: boolean;
  onClick: (label: string) => void;
}) {
  return (
    <IconButton
      sx={{
        px: 0,
      }}
      onClick={() => {
        onClick(label);
      }}
    >
      <Stack alignItems="center">
        {selected ? selectedIcon : icon}
        <Typography variant="caption" fontWeight={fontWeight.Medium}>
          {label}
        </Typography>
      </Stack>
    </IconButton>
  );
}
function SFBottoms({ selectedLabel }: { selectedLabel: LabelType }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ width: '100%' }} bgcolor="white">
      <Stack direction="row" justifyContent="space-between">
        {/* 포인트 인앱결제에 관련 로직이 없기 때문에 1차 심사 때 제외 */}
        {/* <BottomNavigationItem
          icon={<SFPointOutlinedIcon />}
          label="포인트"
          selectedIcon={<SFPointFilledIcon />}
          selected={selectedLabel === '포인트'}
          onClick={() => {
            navigate('/point');
          }}
        /> */}
        <BottomNavigationItem
          icon={<SFWalletOutlinedIcon />}
          label="지갑"
          selectedIcon={<SFWalletFilledIcon />}
          selected={selectedLabel === '지갑'}
          onClick={() => {
            navigate('/wallet');
          }}
        />
        <IconButton
          sx={{
            p: 0,
            position: 'relative',
            bottom: 10,
          }}
          onClick={() => {
            qr_camera_call();

          }}
        >
          <Stack alignItems="center">
            <SFQrScannerIcon />
          </Stack>
        </IconButton>

        {/* <BottomNavigationItem
          icon={<SFStoreOutlinedIcon />}
          label="스토어"
          selectedIcon={<SFStoreOutlinedIcon />}
          selected={selectedLabel === '스토어'}
          onClick={() => {
            // alert('준비 중 입니다.');
            window.open('https://shop.hupayx.io/');
            // navigate('/store');
          }}
        /> */}
        <BottomNavigationItem
          icon={<SFMyOutlinedIcon />}
          label="MY"
          selectedIcon={<SFMyFilledIcon />}
          selected={selectedLabel === 'MY'}
          onClick={() => {
            navigate('/my');
          }}
        />
      </Stack>
    </Box>
  );
}
type SFBottomNavigationProps = {
  selectedLabel: LabelType;
  isPositionRelative?: boolean;
  isContainerWidth?: string;
};
export default function SFBottomNavigation(payload: SFBottomNavigationProps) {
  const { selectedLabel, isPositionRelative, isContainerWidth } = payload;

  return (
    // transform: 'translateY(-50%)'  position={'relative'}
    <>
      {isPositionRelative ? (
        <Box sx={{ transform: 'translateY(-50%)' }} position="relative" bottom={0}>
          {isContainerWidth ? (
            <Container maxWidth="sm">
              <SFBottoms selectedLabel={selectedLabel} />
            </Container>
          ) : (
            <SFBottoms selectedLabel={selectedLabel} />
          )}
        </Box>
      ) : (
        <SFBottoms selectedLabel={selectedLabel} />
      )}
    </>
  );
}
